/**
 * Drawer Submenu - 二级、三级菜单交互逻辑
 * 处理二级菜单的抽屉式导航和三级菜单的手风琴展开
 */

class DrawerSubmenu {
  constructor() {
    this.init();
  }

  init() {
    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // 使用事件委托处理所有submenu相关的点击事件
    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-submenu-toggle]');
      if (target) {
        this.handleSubmenuToggle(e, target);
      }
    });

    // 处理返回按钮
    document.addEventListener('click', (e) => {
      const backBtn = e.target.closest('.drawer-submenu__back-btn');
      if (backBtn) {
        this.handleBackButton(e);
      }
    });

    // 处理关闭按钮
    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('.drawer-submenu__close-btn');
      if (closeBtn) {
        this.handleCloseButton(e);
      }
    });
  }

  handleSubmenuToggle(e, target) {
    e.preventDefault();

    const subList = target.nextElementSibling;
    if (!subList || !subList.classList.contains('drawer-submenu__sub-list')) {
      return;
    }

    const isExpanded = target.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.collapseSubmenu(target, subList);
    } else {
      this.expandSubmenu(target, subList);
    }
  }

  expandSubmenu(toggle, subList) {
    // 设置展开状态
    toggle.setAttribute('aria-expanded', 'true');
    subList.classList.add('expanded');
    
    // 计算实际高度并应用
    setTimeout(() => {
      const scrollHeight = subList.scrollHeight;
      subList.style.maxHeight = scrollHeight + 'px';
    }, 10);
  }

  collapseSubmenu(toggle, subList) {
    // 设置收起状态
    toggle.setAttribute('aria-expanded', 'false');
    subList.classList.remove('expanded');
    subList.style.maxHeight = '0px';
  }

  handleBackButton(e) {
    e.preventDefault();
    
    // 收起所有展开的三级菜单
    const currentSubmenu = e.target.closest('.drawer-submenu');
    if (currentSubmenu) {
      const expandedToggles = currentSubmenu.querySelectorAll('[aria-expanded="true"]');
      expandedToggles.forEach(toggle => {
        const subList = toggle.nextElementSibling;
        if (subList) {
          this.collapseSubmenu(toggle, subList);
        }
      });
    }

    // 隐藏当前二级菜单
    const submenuWrapper = e.target.closest('.drawer-menu__submenu-wrapper');
    if (submenuWrapper) {
      submenuWrapper.classList.remove('visible');
      submenuWrapper.setAttribute('aria-hidden', 'true');
    }

    // 触发drawer-menu的返回逻辑
    const backEvent = new CustomEvent('drawer-submenu:back');
    document.dispatchEvent(backEvent);
  }

  handleCloseButton(e) {
    e.preventDefault();
    
    // 触发drawer-menu的关闭逻辑
    const closeEvent = new CustomEvent('drawer-submenu:close');
    document.dispatchEvent(closeEvent);
  }

  // 初始化所有submenu的状态 - 默认展开三级菜单
  initializeState() {
    const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      const subList = toggle.nextElementSibling;
      
      // 默认展开状态
      toggle.setAttribute('aria-expanded', 'true');
      
      if (subList && subList.classList.contains('drawer-submenu__sub-list')) {
        subList.classList.add('expanded');
        // 计算实际高度并设置
        setTimeout(() => {
          const scrollHeight = subList.scrollHeight;
          subList.style.maxHeight = scrollHeight + 'px';
        }, 10);
      }
    });
  }

  // 重置所有submenu状态 - 默认展开三级菜单
  resetState() {
    const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      const subList = toggle.nextElementSibling;
      
      toggle.setAttribute('aria-expanded', 'true');
      
      if (subList && subList.classList.contains('drawer-submenu__sub-list')) {
        subList.classList.add('expanded');
        // 计算实际高度并设置
        setTimeout(() => {
          const scrollHeight = subList.scrollHeight;
          subList.style.maxHeight = scrollHeight + 'px';
        }, 10);
      }
    });
  }
}

// 初始化DrawerSubmenu
const drawerSubmenu = new DrawerSubmenu();

// 暴露到全局作用域，供其他脚本使用
window.DrawerSubmenu = drawerSubmenu; 